import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type AuthStatus = 'Authenticating' | 'Completed' | '';
export interface IUserDataInitialState {
  authToken: string;
  expiry: number;
  refreshInterval: number;
  refreshToken: string;
  userDetails: any;
  lang: string;
  region: string;
  authStatus: AuthStatus;
}

const userDataInitialState: IUserDataInitialState = {
  authToken: '',
  expiry: 0,
  refreshInterval: 0,
  refreshToken: '',
  userDetails: { first_name: '', last_name: '', user_setting: [0] },
  lang: 'en',
  region: 'us',
  authStatus: '',
};

const userDataSlice = createSlice({
  name: 'userData',
  initialState: { ...userDataInitialState },
  reducers: {
    setUserData: (state, action: PayloadAction<object>) => ({ ...state, ...action.payload }),
    updateAuthStatus: (state, action: PayloadAction<object>) => ({ ...state, ...action.payload }),
    updateUserSetting: (state, action: PayloadAction<object>) => {
      const updatedState = JSON.parse(JSON.stringify(state));
      updatedState.userDetails.user_setting[0] = action.payload;
      return updatedState;
    },
    resetUserData: () => userDataInitialState,
  },
});

export const { setUserData, updateUserSetting, updateAuthStatus, resetUserData } = userDataSlice.actions;
export default userDataSlice.reducer;
